export default "__VITE_ASSET__CAfk71Ec__"